import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Diensten',
    links: [
      { label: 'Product Sourcing', href: '/diensten/product-sourcing' },
      { label: 'Prijsoptimalisatie', href: '/diensten/prijsoptimalisatie' },
      { label: 'Private Label & Maatwerk', href: '/diensten/private-label' },
      { label: 'Productiebegeleiding', href: '/diensten/productiebegeleiding' },
      { label: 'DDP Levering', href: '/diensten/ddp-levering' },
      { label: 'Leveranciersbeheer', href: '/diensten/leveranciersbeheer' },
    ],
  },
  {
    title: 'Voor wie',
    links: [
      { label: 'Horeca', href: '/voor-wie/horeca' },
      { label: 'Webshops', href: '/voor-wie/webshops' },
      { label: 'Retail & Groothandel', href: '/voor-wie/retail' },
      { label: 'Gyms & Sportclubs', href: '/voor-wie/gyms' },
      { label: 'Bedrijven & B2B', href: '/voor-wie/bedrijven' },
      { label: 'Particulieren', href: '/voor-wie/particulieren' },
      { label: 'Juweliers', href: '/voor-wie/juweliers' },
      { label: 'Overig', href: '/voor-wie/overig' },
    ],
  },
  {
    title: 'Inkopen uit China',
    links: [
      { label: 'Inkopen uit China', href: '/inkopen-uit-china' },
      { label: 'Goedkoop Inkopen China', href: '/goedkoop-inkopen-china' },
      { label: 'Private Label China', href: '/private-label-china' },
      { label: 'Sourcing Service', href: '/sourcing-service' },
      { label: 'Blog & Winning Products', href: '/blog' },
      { label: 'Wie zijn wij', href: '/wie-zijn-wij' },
      { label: 'Hoe het werkt', href: '/hoe-het-werkt' },
      { label: 'FAQ', href: '/faq' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Winning Products',
    links: [
      { label: 'Geborduurde T-shirts', href: '/blog/geborduurde-tshirts-inkopen-china' },
      { label: 'Luxe wandlampen', href: '/blog/luxe-wandlampen-inkopen-china' },
      { label: 'EV laadkabels', href: '/blog/ev-laadkabels-inkopen-china' },
      { label: 'Bedrukte paper bags', href: '/blog/bedrukte-paper-bags-inkopen-china' },
      { label: 'E-choppers', href: '/blog/e-choppers-inkopen-china' },
      { label: 'Bedrukte tissues horeca', href: '/blog/bedrukte-tissues-horeca-inkopen-china' },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#050E1A] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
          <div className="lg:col-span-2">
            <div className="mb-5">
              <img
                src="https://static.readdy.ai/image/15bdf5788918520e40e960585d4ea965/3037d4ed8e2d758e66815cdcd69eb3cd.png"
                alt="DUC - Direct uit China"
                className="h-[100px] w-auto object-contain"
              />
            </div>
            <p className="text-[#3B9EE8] text-sm font-500 mb-4 italic">
              &ldquo;Van inkoop tot aftercare, volledig geregeld&rdquo;
            </p>
            <p className="text-white/45 text-sm leading-relaxed mb-7 max-w-xs">
              DUC helpt bedrijven en particulieren direct inkopen bij fabrikanten in China.
              Betere prijzen, betrouwbare kwaliteit, volledige begeleiding.
            </p>

            <div className="flex flex-col gap-3 mb-6">
              <a
                href="https://wa.me/31624359162?text=Hi%20Shubam%2C%20ik%20wil%20graag%20meer%20informatie%20over%20inkopen%20uit%20China."
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center gap-3 text-white/50 hover:text-[#3B9EE8] transition-colors group cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/5 group-hover:bg-[#3B9EE8]/10 transition-colors">
                  <i className="ri-whatsapp-line text-sm" />
                </div>
                <span className="text-sm">+31 6 24 35 91 62</span>
              </a>
              <a
                href="mailto:Info@directuitchina.nl"
                className="flex items-center gap-3 text-white/50 hover:text-[#3B9EE8] transition-colors group cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/5 group-hover:bg-[#3B9EE8]/10 transition-colors">
                  <i className="ri-mail-line text-sm" />
                </div>
                <span className="text-sm">Info@directuitchina.nl</span>
              </a>
            </div>

            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-whatsapp-line', href: 'https://wa.me/31624359162?text=Hi%20Shubam%2C%20ik%20wil%20graag%20meer%20informatie%20over%20inkopen%20uit%20China.', label: 'WhatsApp' },
                { icon: 'ri-instagram-line', href: 'https://www.instagram.com/directuitchina/', label: 'Instagram' },
                { icon: 'ri-linkedin-fill', href: 'http://linkedin.com/company/direct-uit-china', label: 'LinkedIn' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 text-white/50 hover:text-[#3B9EE8] hover:border-[#3B9EE8]/50 transition-all duration-200"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-700 text-white text-sm mb-5 tracking-wide uppercase">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/') ? (
                      <Link
                        to={link.href}
                        className="text-white/45 hover:text-[#3B9EE8] text-sm transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        rel="nofollow"
                        className="text-white/45 hover:text-[#3B9EE8] text-sm transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mb-8 p-5 border border-white/8 rounded-xl flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <p className="text-white font-600 text-sm">Klaar om goedkoper in te kopen?</p>
            <p className="text-white/40 text-xs">Ontvang binnen 24 uur gratis een prijsindicatie.</p>
          </div>
          <div className="flex gap-3">
            <a
              href="/#contact"
              className="bg-[#3B9EE8] hover:bg-[#2D85C5] text-white font-700 text-xs px-6 py-2.5 rounded-md transition-all cursor-pointer whitespace-nowrap"
            >
              Gratis Prijscheck
            </a>
          </div>
        </div>

        <div className="border-t border-white/8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {year} Direct uit China (DUC). Alle rechten voorbehouden.
          </p>
          <div className="flex items-center gap-6">
            {[
              { label: 'Privacybeleid', href: '/privacybeleid' },
              { label: 'Algemene voorwaarden', href: '/algemene-voorwaarden' },
              { label: 'Cookiebeleid', href: '/cookiebeleid' },
            ].map((item) => (
              item.href.startsWith('/') ? (
                <Link
                  key={item.label}
                  to={item.href}
                  className="text-white/30 hover:text-white/60 text-xs transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={item.label}
                  href={item.href}
                  rel="nofollow"
                  className="text-white/30 hover:text-white/60 text-xs transition-colors"
                >
                  {item.label}
                </a>
              )
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
